import ErrorAlert from '@/components/ErrorAlert';
import { Center, Text } from '@mantine/core';

import { Link } from 'react-router-dom';

const ForgotPasswordResetNoToken = () => {
  return (
    <>
      <Text fz="2rem" fw="bold" mt="md">
        Invalid Reset Link
      </Text>
      <ErrorAlert>
        Invalid or missing reset token. Please request a new password reset link.
      </ErrorAlert>
      <Center>
        <Text mt="sm">
          <Link to="/forgot_password/email">Request New Reset Link</Link>
        </Text>
      </Center>
      <Center>
        <Text mt="sm">
          <Link to="/login">Back to Login</Link>
        </Text>
      </Center>
    </>
  );
};

export default ForgotPasswordResetNoToken;
